import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { TerminationResistanceMeasure } from "../../../models/schemas/measures/electrical.schema";
import { TERMINATION_RESISTANCE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 종단 저항 컨트롤러
 * 판정 기준: 측정값 >= 기준값 (기본 75Ω)
 */
export class TerminationResistanceController extends MeasureController<TerminationResistanceMeasure> {
  protected getDefaultData(): TerminationResistanceMeasure {
    return {
      label: "",
      standardValue: TERMINATION_RESISTANCE_THRESHOLDS.defaultStandard,
      measuredValue: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { standardValue = TERMINATION_RESISTANCE_THRESHOLDS.defaultStandard, measuredValue } =
      this.data;

    // 데이터 미입력 시
    if (!measuredValue) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // 판정: 측정값 >= 기준값
    const result: JudgmentResultType = measuredValue >= standardValue ? "GOOD" : "BAD";

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return "종단 저항이 기준값 이상으로 정상";
    }
    return "종단 저항이 기준값 미만. 점검 필요";
  }
}
